import React, { useRef, useEffect } from 'react'
import * as classes from './TextArea.module.scss'
import cn from 'classnames'

export const TextArea = ({ name, label, value, onChange, placeholder = ' ', className }) => {
    const textareaRef = useRef(null)

    useEffect(() => {
        textareaRef.current.style.height = 'auto'
        textareaRef.current.style.height = `${textareaRef.current.scrollHeight - 10}px`
    }, [value])

    return (
        <div className={cn(classes.TextAreaWrap, className)}>
            <div className={classes.Inner}>
                <textarea className={classes.TextArea} name={name} id={name} onChange={onChange} ref={textareaRef} value={value} placeholder={placeholder} />

                <label className={classes.Label} htmlFor={name}>
                    {label}
                </label>
            </div>
        </div>
    )
}
